module.exports = __webpack_public_path__ + "static/media/2.352d2f9a.svg";